import React from 'react';
import { Link, useIntl } from 'gatsby-plugin-intl';
import BannerEscalavel from '../BannerEscalavel';
import imgNotebook from '../img/notebook-catalogo.webp';
import imgFaixaTitulo from './img/faixa-titulo.svg';
import imgFaixaSubtitulo from './img/faixa-subtitulo.svg';
import imgIconePesquisa from './img/icone-pesquisa.svg';
import imgIconeFerramentaVendas from './img/icone-ferramenta-vendas.svg';
import imgIconeLayout from './img/icone-layout.svg';
import imgIconeTempoReal from './img/icone-tempo-real.svg';
import imgIconeGestao from './img/icone-gestao.svg';
import Icone from './Icone';
import IconeCarro from './IconeCarro';
import './style.scss';

const itens = [
  { id: 'Pesquisa rápida e fácil', icone: <Icone src={imgIconePesquisa} /> },
  { id: 'Recurso de Busca por Placa', icone: <IconeCarro /> },
  { id: 'Ferramenta de vendas (possibilidade de integração com seu sistema)', icone: <Icone src={imgIconeFerramentaVendas} />, quebraEmDuasLinhas: true },
  { id: 'Layout personalizado com a sua marca', icone: <Icone src={imgIconeLayout} /> },
  { id: 'Atualização em tempo real', icone: <Icone src={imgIconeTempoReal} /> },
  { id: 'Gestão completa dos dados pela sua equipe', icone: <Icone src={imgIconeGestao} /> },
];

const BannerCatalogoLojistas = () => {
  const intl = useIntl();

  return (
    <BannerEscalavel className="banner-catalogo-lojistas">
      <img className="banner-catalogo-lojistas-notebook" src={imgNotebook} alt="" />

      <img className="banner-catalogo-lojistas-faixa-subtitulo" src={imgFaixaSubtitulo} alt="" />
      <p className="banner-catalogo-lojistas-subtitulo">
        {intl.formatMessage({ id: 'O catálogo que conquistou o mercado de AUTOPEÇAS!' })}
      </p>

      <img className="banner-catalogo-lojistas-faixa-titulo" src={imgFaixaTitulo} alt="" />
      <h2 className="banner-catalogo-lojistas-titulo">
        {intl.formatMessage({ id: 'Catálogo Ideia 2001: amplamente utilizado por lojistas, compradores e mecânicos de todo o Brasil!' })}
      </h2>

      <ul className="banner-catalogo-lojistas-lista">
        {itens.map(({ id, icone, quebraEmDuasLinhas }) => (
          <li key={id} className={`item${quebraEmDuasLinhas ? ' item-duas-linhas' : ''}`}>
            {icone}
            <span className={`texto${quebraEmDuasLinhas ? ' texto-duas-linhas' : ''}`}>{intl.formatMessage({ id })}</span>
          </li>
        ))}
      </ul>

      <div className="banner-catalogo-lojistas-chamada">
        <p>{intl.formatMessage({ id: 'Mais agilidade para seus clientes.' })}</p>
        <p>{intl.formatMessage({ id: 'Mais oportunidades para sua empresa.' })}</p>
      </div>

      <Link to="/catalogo-expresso-instalado" className="banner-catalogo-lojistas-botao">
        {intl.formatMessage({ id: 'Conheça mais.' })}
      </Link>
    </BannerEscalavel>
  );
};

export default BannerCatalogoLojistas;
